'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver from "./com.raquo.airstream.common.-Internal-Try-Observer.js";
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dStream from "./com.raquo.airstream.common.-Single-Parent-Stream.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream from "./com.raquo.airstream.core.-Writable-Stream.js";
import * as $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dStream from "./com.raquo.airstream.distinct.-Distinct-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_timing_SyncDelayStream(parent, after) {
  this.Fk = null;
  this.Fj = false;
  this.Fl = null;
  this.Fh = null;
  this.Fi = null;
  this.Fm = false;
  this.yV = null;
  this.v5 = null;
  this.v6 = 0;
  this.yV = parent;
  this.Fk = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.v5 = (void 0);
  var x = parent.dT();
  var that = after.dT();
  this.v6 = ((1 + ((x > that) ? x : that)) | 0);
}
export { $c_Lcom_raquo_airstream_timing_SyncDelayStream as $c_Lcom_raquo_airstream_timing_SyncDelayStream };
$p = $c_Lcom_raquo_airstream_timing_SyncDelayStream.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_timing_SyncDelayStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_SyncDelayStream() {
}
export { $h_Lcom_raquo_airstream_timing_SyncDelayStream as $h_Lcom_raquo_airstream_timing_SyncDelayStream };
$h_Lcom_raquo_airstream_timing_SyncDelayStream.prototype = $p;
$p.dP = (function() {
  return this.Fk;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.Fj;
});
$p.fm = (function() {
  return this.Fl;
});
$p.ea = (function(x$1) {
  this.Fj = x$1;
});
$p.gD = (function(x$1) {
  this.Fl = x$1;
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.hm = (function(observer) {
});
$p.ew = (function() {
  return this.Fh;
});
$p.ey = (function() {
  return this.Fi;
});
$p.hw = (function() {
  return this.Fm;
});
$p.g1 = (function(x$1) {
  this.Fm = x$1;
});
$p.hf = (function(x$0) {
  this.Fh = x$0;
});
$p.hg = (function(x$0) {
  this.Fi = x$0;
});
$p.hp = (function() {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.yV);
});
$p.hn = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dStream.$f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$p.ho = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dStream.$f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$p.fW = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.fV = (function(nextError, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.eB = (function() {
  return this.yV;
});
$p.dT = (function() {
  return this.v6;
});
$p.fX = (function(nextValue, transaction) {
  if ((!transaction.SY(this))) {
    transaction.TM(this);
  }
  this.v5 = nextValue;
});
$p.XX = (function(transaction) {
  var x = this.v5;
  if ((x !== (void 0))) {
    this.v5 = (void 0);
    $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dStream.$f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, x, transaction);
  }
});
$p.hi = (function(isSame) {
  return new $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dStream.$c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_SyncDelayStream = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_timing_SyncDelayStream, "com.raquo.airstream.timing.SyncDelayStream", ({
  ho: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  ba: 1,
  bm: 1,
  as: 1,
  bI: 1,
  aj: 1,
  c1: 1,
  ay: 1,
  gP: 1
}));
export { $d_Lcom_raquo_airstream_timing_SyncDelayStream as $d_Lcom_raquo_airstream_timing_SyncDelayStream };
